import React, { useCallback, useEffect } from "react";
import Layout, { LAYOUT_QUERY } from "@/components/Layout";

import { Form, Input, Button, Checkbox, Typography } from "antd";

import { useRouter } from "next/router";

const { Title } = Typography;

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { RADIO_STATE } from "@/store/liveRadio/action";
import { connect } from "react-redux";
import { compose } from "redux";
import { fetchAPI } from "@/utils/api/api";
import NicePage from "@/components/NicePage";

require("@/styles/login.less");
import Link from "next/link";
import withAuthentication from "@/utils/hocs/withAuthentication";
import { canViewAdminPage, canViewMessages } from "@/utils/auth/roleTests";

const ADMIN_PAGE_QUERY = `
query GetAdminPage {
	${LAYOUT_QUERY}
}
`;

const LoginPage: React.FC<{ graphQLData: any }> = ({ graphQLData }) => {
  // get user role from redux state
  const role = useSelector<RootState>(({ auth }) => auth.role) as string;

  return (
    <Layout title="Admin Index" data={graphQLData}>
      <NicePage style={{ padding: "5em" }}>
        <Title>Admin Portal</Title>
        {canViewMessages(role) && (
          <p>
            <Link href="/admin/message-viewer">View Messages</Link>
          </p>
        )}
      </NicePage>
    </Layout>
  );
};

const mapState = (state: RootState) => ({
  playing: state.liveRadio.state === RADIO_STATE.PLAYING,
});

export async function getStaticProps() {
  const data = await fetchAPI(ADMIN_PAGE_QUERY);
  return {
    props: {
      graphQLData: data,
    },
    revalidate: 1,
  };
}

const connector = connect(mapState);

export default compose(
  connector,
  withAuthentication(canViewAdminPage)
)(LoginPage);
